import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "d-flex align-items-start" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "pi pi-chevron-left mr-1" }, null, -1)
const _hoisted_3 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_4 = { class: "ml-auto d-flex align-items-center" }
const _hoisted_5 = { class: "text-danger" }
const _hoisted_6 = { class: "floor-title form-custom" }
const _hoisted_7 = /*#__PURE__*/_createVNode("hr", { class: "hr apartments-section" }, null, -1)
const _hoisted_8 = { class: "mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_Divider = _resolveComponent("Divider")
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_ElDropdownItem = _resolveComponent("ElDropdownItem")
  const _component_ElDropdownMenu = _resolveComponent("ElDropdownMenu")
  const _component_ElDropdown = _resolveComponent("ElDropdown")
  const _component_InputText = _resolveComponent("InputText")
  const _component_ApartmentItem = _resolveComponent("ApartmentItem")
  const _component_ElScrollbar = _resolveComponent("ElScrollbar")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_TabView = _resolveComponent("TabView")
  const _component_DialogAddEditBuilding = _resolveComponent("DialogAddEditBuilding")
  const _component_DialogAddEditApartment = _resolveComponent("DialogAddEditApartment")
  const _component_DialogConfirmDelete = _resolveComponent("DialogConfirmDelete")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", null, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", null, [
          _createVNode(_component_router_link, {
            to: _ctx.backLink,
            class: "fs-18 text-decoration-none text-gray"
          }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("general.backTo")) + ": " + _toDisplayString(_ctx.$t("AppResourceEP.Structure")), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          (_ctx.building)
            ? (_openBlock(), _createBlock("h1", _hoisted_3, _toDisplayString(_ctx.building.name), 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_Divider, { layout: "vertical" }),
          _createVNode(_component_ElDropdown, {
            trigger: "click",
            placement: "bottom-end",
            "popper-class": "el-dropdown__popper el-dropdown--context"
          }, {
            dropdown: _withCtx(() => [
              _createVNode(_component_ElDropdownMenu, { style: {"width":"300px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_ElDropdownItem, { onClick: _ctx.toggleAddApartment }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("AppResourceEP.AddApartments")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_ElDropdownItem, { onClick: _ctx.toggleAddEditBuilding }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("AppResourceEP.Rename")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_ElDropdownItem, { onClick: _ctx.toggleDeleteBuildingConfirm }, {
                    default: _withCtx(() => [
                      _createVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("AppResource.Delete")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Button, {
                disabled: _ctx.currentEntrancePlant.syncStatus?.isPlantActive,
                class: "p-button-text p-button-secondary p-1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_InlineSvgScoped, {
                    src: 
                                require('@/assets/images/icons/icon-ellipsis-v.svg')
                            ,
                    "aria-label": "icon-ellipsis-v"
                  }, null, 8, ["src"])
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    (
            _ctx.currentEntrancePlant.addressingType ==
            _ctx.AddressingType.BuildingRiserFloorApartment
        )
      ? (_openBlock(), _createBlock(_component_TabView, {
          key: 0,
          class: "p-tabview--custom tab-riser-select mb-2"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.buildingStructure, (riserTab, riserIndex) => {
              return (_openBlock(), _createBlock(_component_TabPanel, {
                key: riserIndex,
                header: riserTab.riser.name
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ElScrollbar, { class: "apartments-cards-list__brfa" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(riserTab.floors, (floorsection, floorIndex) => {
                        return (_openBlock(), _createBlock("div", {
                          key: floorIndex,
                          class: "mb-5"
                        }, [
                          _createVNode("div", _hoisted_6, [
                            _createVNode(_component_InputText, {
                              class: "fs-18 text-gray text-uppercase ml-3",
                              modelValue: floorsection.floor.name,
                              "onUpdate:modelValue": ($event: any) => (
                                    _ctx.verifyValidityOfName(
                                        $event,
                                        floorsection.floor
                                    )
                                )
                            }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                            _hoisted_7
                          ]),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(floorsection.apartments, (apartment, apartmentIndex) => {
                            return (_openBlock(), _createBlock(_component_ApartmentItem, {
                              class: "apartment-card",
                              key: apartmentIndex,
                              apartment: apartment,
                              onEditApartment: _ctx.toggleEditApartment
                            }, null, 8, ["apartment", "onEditApartment"]))
                          }), 128))
                        ]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1032, ["header"]))
            }), 128))
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_ElScrollbar, {
          key: 1,
          class: "apartments-cards-list"
        }, {
          default: _withCtx(() => [
            _createVNode("div", _hoisted_8, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.apartments, (apartment, index) => {
                return (_openBlock(), _createBlock(_component_ApartmentItem, {
                  class: "apartment-card",
                  key: index,
                  apartment: apartment,
                  onEditApartment: _ctx.toggleEditApartment
                }, null, 8, ["apartment", "onEditApartment"]))
              }), 128))
            ])
          ]),
          _: 1
        })),
    _createVNode(_component_DialogAddEditBuilding, {
      isVisible: _ctx.isVisibleAddEditBuilding,
      buildingToEdit: _ctx.building,
      onHideDialog: _ctx.toggleAddEditBuilding,
      onUpdateList: _ctx.handleUpdateList
    }, null, 8, ["isVisible", "buildingToEdit", "onHideDialog", "onUpdateList"]),
    _createVNode(_component_DialogAddEditApartment, {
      building: _ctx.building,
      isVisible: _ctx.isVisibleAddEditApartment,
      apartmentToEdit: _ctx.apartmentToEdit,
      onHideDialog: _ctx.hideAddEditApartment,
      onUpdateList: _ctx.handleUpdateList
    }, null, 8, ["building", "isVisible", "apartmentToEdit", "onHideDialog", "onUpdateList"]),
    _createVNode(_component_DialogConfirmDelete, {
      "is-visible": _ctx.isVisibleDeleteBuildingConfirm,
      title: _ctx.$t('AppResourceEP.BuildingDeletionPopupTitle'),
      message: _ctx.$t('AppResourceEP.BuildingDeletionPopupMessage'),
      onHideDialog: _ctx.toggleDeleteBuildingConfirm,
      onConfirm: _ctx.handleDeleteBuilding
    }, null, 8, ["is-visible", "title", "message", "onHideDialog", "onConfirm"])
  ], 64))
}